<template>
  <b-modal
    ref="modal"
    size="lg"
    class="text-left font_Montserrat"
    centered
    :visible="visible"
    @hidden="onModalHidden"
    hide-footer
  >
    <template slot="modal-header">
      <b-row class="w-100">
        <b-col class="text-left question-text" sm="12" lg="8" offset-lg="2">
          <h5 class="modal-title v2_info-popup__title">
            <span>Select Board Certification</span>
          </h5>
        </b-col>
      </b-row>
    </template>

    <b-row class="my-4">
      <b-col class="text-left question-text" sm="12" lg="8" offset-lg="2">
        <b-form-group
          label="Certifying Board:"
          label-class="v3_color_teal"
        >
          <div class="phairify-select-wrapper">
            <b-form-select
              v-model="board"
              class="phairify-border-grey"
              :options="boardOptions"
              @change="onBoardChange"
            >
              <template slot="first">
                <option :value="null" disabled>
                  -- Select --
                </option>
              </template>
            </b-form-select>
          </div>
        </b-form-group>
        <b-form-group
          label="Certification:"
          label-class="v3_color_teal"
        >
          <div class="phairify-select-wrapper">
            <b-form-select
              :disabled="!board"
              v-model="certification"
              class="rounded-0 phairify-border-grey"
              :options="certificationOptions"
            >
              <template slot="first">
                <option :value="null" disabled>
                  -- Select --
                </option>
              </template>
            </b-form-select>
          </div>
        </b-form-group>
        <b-form-group
          label="Certification Status:"
          label-class="v3_color_teal"
        >
          <div class="phairify-select-wrapper">
            <b-form-select
              v-model="status"
              class="phairify-border-grey"
              :options="statusOptions"
            >
            </b-form-select>
          </div>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="d-flex justify-content-around" sm="12" lg="8" offset-lg="2">
        <b-button
          variant="v3_teal_outline"
          class="w-25"
          @click="add"
          :disabled="!certification"
        >
          <template v-if="!addLoading">Add</template>
          <template v-else>
            <b-spinner small />
            <span>Add...</span>
          </template>
        </b-button>
        <b-button variant="v3_teal_outline" class="w-25" @click="$refs.modal.hide(true)">
          Cancel
        </b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { BOARD_CERTIFICATION_STATUS_OPTIONS } from '@/helpers/BoardCertificationHelper';

export default {
  name: 'UserProfileBoardCertificationModal',
  props: {
    boards: {
      type: Array,
      required: true,
    },
    certifications: {
      type: Array,
      required: true,
    },
    excludedCertificationIds: {
      type: Array,
      default: () => [],
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      board: null,
      certification: null,
      status: 1,
      addLoading: false,
    };
  },
  computed: {
    statusOptions: function () {
      return BOARD_CERTIFICATION_STATUS_OPTIONS;
    },
    boardOptions: function () {
      return this.boards.map((b) => ({
        value: b.id,
        text: b.title,
      }));
    },
    certificationOptions: function () {
      if (!this.board) {
        return [];
      }

      return this.certifications
        .filter(
          (c) =>
            c.certifying_board_id === this.board &&
            !this.excludedCertificationIds.includes(c.id)
        )
        .map((c) => ({
          value: c.id,
          text: c.title,
        }));
    },
  },
  methods: {
    showModal: function () {
      this.$refs.modal.show();
    },
    onModalHidden() {
      this.$emit('modalClose');
    },
    add: function () {
      this.$emit('addItem', {
        id: this.certification,
        is_certified: this.status,
      });
      this.$refs.modal.hide(true);
    },
    onBoardChange: function () {
      this.certification = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.phairify-select-wrapper {
  min-width: 215px;
  &:after {
    content: '\F0140';
    font-size: 22px;
    right: 10px;
  }
  .custom-select {
    height: 100%;
    padding: 15px;
    border-radius: 4px;
  }
}
</style>
